
function generateGUID () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

let audioContexts = [];

export default {
  /**
   * Returns an available audio context
   */
  getFreeAudioContext () {
    if (audioContexts.length > 5) {
      return;
    }

    const audioContext = {
      context: new AudioContext(),
      guid: generateGUID()
    };

    audioContexts.push(audioContext);

    return audioContext;
  },

  freeAudioContext (guid) {
    const audioContext = audioContexts.filter(ctx => ctx.guid === guid)[0];
    const newAudioContexts = audioContexts.filter(ctx => ctx.guid !== guid);

    audioContext.context.close();

    audioContexts = newAudioContexts;
  }
};



// WEBPACK FOOTER //
// ./src/components/audio-contexts.js